import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FiTrendingUp, FiArrowUp, FiHash } from "react-icons/fi";
import "./widgets.css";

const TrendingTopicsWidget = ({ topics }) => {
  if (!topics || topics.length === 0) {
    return (
      <motion.div
        className="cbx-widget cbx-widget--trending"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <div className="cbx-widget__header">
          <h3 className="cbx-widget__title">
            <FiTrendingUp className="cbx-widget__title-icon" />
            Trending Topics
          </h3>
        </div>
        <div className="cbx-widget__empty">
          <FiHash className="cbx-widget__empty-icon" />
          <p className="cbx-widget__empty-text">No trending topics yet</p>
        </div>
        <div className="cbx-widget__copyright">© 2025 ResearchPro</div>
      </motion.div>
    );
  }

  return (
    <motion.div
      className="cbx-widget cbx-widget--trending"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="cbx-widget__header">
        <h3 className="cbx-widget__title">
          <FiTrendingUp className="cbx-widget__title-icon" />
          Trending Topics
        </h3>
      </div>

      <div className="cbx-trending-list">
        {topics.map((topic, index) => (
          <Link
            key={topic.tag || topic._id || index}
            to={`/topics/${topic.tag}`}
            className="cbx-trending-item"
          >
            <span className="cbx-trending-rank">{index + 1}</span>
            <div className="cbx-trending-info">
              <h4 className="cbx-trending-tag">#{topic.tag}</h4>
              <p className="cbx-trending-count">
                {topic.count?.toLocaleString() || 0} posts
              </p>
            </div>
            {topic.growthRate > 0 && (
              <div className="cbx-trending-growth">
                <FiArrowUp />
                <span>{topic.growthRate}%</span>
              </div>
            )}
          </Link>
        ))}
      </div>

      <div className="cbx-widget__footer">
        <Link to="/topics/trending" className="cbx-widget__footer-link">
          See All Trending →
        </Link>
      </div>

      <div className="cbx-widget__copyright">© 2025 ResearchPro</div>
    </motion.div>
  );
};

export default TrendingTopicsWidget;
